/**
 * HESAP RENGİ (kullanıcı kararı 12.10.2026, seçenek A): hesabın ADI göründüğü
 * her yerde hesabın renginde; satır başında ince bir renk şeridi. Tutar,
 * getiri ve uyarı metinleri BOYANMAZ — onların rengi bir yargıdır
 * (CLAUDE.md §6). Liste kapalı ve yargı renklerini içermez
 * (`HESAP_RENKLERI`); ton temaya göre `--pf-hesap-*` belirtecinden gelir.
 */

import type { CSSProperties, ReactNode } from "react";
import type { HesapRengi } from "@parafon/contracts/local-api";
import { cx } from "./primitives";
import { M } from "../dil";

export const HESAP_RENK_ADI: Readonly<Record<HesapRengi, string>> = M.hesaplar.renk;

export function hesapRengiCss(renk: HesapRengi | undefined): string | undefined {
  return renk === undefined ? undefined : `var(--pf-hesap-${renk})`;
}

/** Satırın ilk hücresine: soldan ince renk şeridi (renksiz hesapta boş). */
export function hesapSeridi(renk: HesapRengi | undefined): CSSProperties | undefined {
  const c = hesapRengiCss(renk);
  return c === undefined ? undefined : { boxShadow: `inset 3px 0 0 ${c}` };
}

/** Hesap adı — rengi varsa o renkte. */
export function HesapAdi({
  renk,
  className,
  renksiz = "text-ink",
  children,
}: {
  readonly renk: HesapRengi | undefined;
  readonly className?: string;
  /** Renksiz hesapta metnin sınıfı (sütunun olağan tonu). */
  readonly renksiz?: string;
  readonly children: ReactNode;
}) {
  const c = hesapRengiCss(renk);
  return (
    <span className={cx(c === undefined && renksiz, className)} data-hesap-rengi={renk} style={c === undefined ? undefined : { color: c }}>
      {children}
    </span>
  );
}
